module.exports = __webpack_public_path__ + "img/p6.886e7c13.png";